// MyWishListController
(function () {
    'use strict';

    angular
        .module('PublicApp.myWishList', [])

        /**
         * MyWishListController
         *
         * @inject $scope
         * @inject __DataStore
         * @inject appServices
         *
         * @return void
         *-------------------------------------------------------- */
        .controller('MyWishListController', [
            '$scope',
            'appServices',
            '__Utils',
            '$compile',
            '__DataStore',
            function MyWishListController($scope, appServices, __Utils, $compile, __DataStore) {
                var scope = this;
                scope.pageStatus = false;


                //manage rating star
                scope.calculateRating = function (value) {
                    var decimal = (value - Math.floor(value));
                    var rated = 0, unrated = 0;
                    if (decimal >= 0 && decimal < 0.5) {
                        rated = Math.round(value);
                        unrated = Math.ceil(5 - value);
                        decimal = 0;
                    } else if (decimal > 0.5 && decimal < 1) {
                        rated = Math.ceil(value);
                        unrated = Math.round(5 - value);
                        decimal = 0;
                    } else {
                        rated = Math.floor(value);
                        unrated = Math.floor(5 - value);
                        decimal = Math.round(decimal);
                    }

                    return (_.repeat('<i class="fa fa-star lw-color-gold"></i>', rated) +
                        _.repeat('<i class="fa fa-star-half-o lw-color-gold"></i>', decimal) +
                        _.repeat('<i class="fa fa-star lw-color-gray"></i>', unrated));
                };

                // product reviews pagination data start
                this.getWishListPaginationData = function (page) {
                    var requestURL = '';

                    if (!_.isEmpty(page) && page.search("http") != -1) {

                        requestURL = page;

                    } else {

                        requestURL = __Utils.apiURL('product.my_wishlist.details');

                        var pageUrl = "";

                        if (page != undefined) {
                            pageUrl = "?page=" + page;
                        }

                        requestURL = requestURL + pageUrl;

                    }

                    __DataStore.fetch(requestURL, { 'fresh': true })
                        .success(function (responseData) {

                            var requestData = responseData.data;

                            appServices.processResponse(responseData, null, function () {

                                scope.wishListData = requestData.wishListData;
                                scope.totalProducts = requestData.totalProducts;
                                scope.paginationLinks = requestData.paginationLinks;

                                scope.wishListCollection = [];
                                _.forEach(scope.wishListData, function (value, key) {

                                    _.defer(function () {
                                        $('#lwWislListProductDesc' + value.productId).html($compile('<p lw-expander slice-count="250">' + value.productDescription + '</p>')($scope));
                                    });

                                    scope.wishListCollection.push({
                                        'productId': value.productId,
                                        'productImage': value.productImage,
                                        'createdOn': value.createdOn,
                                        'detailURL': value.detailURL,
                                        'itemRating': value.itemRating,
                                        'productDescription': value.productDescription,
                                        'productName': value.productName,
                                    });
                                });

                                if (scope.paginationLinks) {
                                    var $paginationLinksElement = $(".lw-pagination-container").html(scope.paginationLinks);
                                }

                                scope.pageStatus = true;
                            });
                        });
                };

                this.getWishListPaginationData('');
                $(".lw-pagination-container").on('click', 'a', function (event) {
                    event.preventDefault();
                    var $this = $(this),
                        url = $this.attr('href');
                    scope.getWishListPaginationData(url);
                });
                // product reviews pagination data stop

                /**
                  * Remove from Wish-list
                  *
                  * @return void
                  *---------------------------------------------------------------- */
                scope.removeFromWishlist = function (productID) {
                    __DataStore.post({
                        'apiURL': 'product.wishlist.remove_process',
                        'productId': productID
                    }, scope).success(function (responseData) {

                        appServices.processResponse(responseData, null, function (reactionCode) {

                            if (reactionCode == 1) {
                                scope.getWishListPaginationData('');
                            }
                        });
                    });
                };
            }
        ])

})();